import { useState, useEffect } from 'react';
import { IoMdClose } from 'react-icons/io';

import { DataState } from '../../context/DataProvider';
import { createTempBot } from '../../services/api';
import { integrationData } from '../../utils/constants';
import Button from '../custom/Button';
import DataFunction from './DataFunction';
import SelectedTriggerItem from '../form/SelectedTriggerItem';

const DataApps = ({ isModalOpen, closeModal, setSelectedValue }) => {
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const { setError, botCreationId, setBotCreationId, userGoogleId } =
    DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState('');

  useEffect(() => {
    if (isModalOpen) {
      const createBot = async () => {
        try {
          const response = await createTempBot({}, userGoogleId);
          if (response.error) {
            setError(JSON.stringify(response.error));
            return;
          }
          if (response.bot_id) {
            setBotCreationId(response.bot_id);
          }
        } catch (err) {
          setError(JSON.stringify(err));
        }
      };
      createBot();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId),
    );
  };

  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };

  const showTestScreen = undefined;
  const isFormLoading = false;
  const handleNewInstructionSubmission = async () => {};

  return (
    <div
      className={`fixed left-0 top-0 z-[100] h-screen w-screen items-center justify-center bg-black bg-opacity-20 backdrop-blur-sm transition-all duration-200 ease-in-out ${
        isModalOpen ? 'flex' : 'hidden'
      }`}
    >
      {!showTestScreen && (
        <div className="bg-1 h-[90%] w-[90%] max-w-3xl overflow-auto rounded-lg">
          <div className="br-1 text-p-text flex justify-between gap-3 border-b px-3 py-5">
            <input
              className="text-p-text bg-2 w-fit resize-none rounded-lg px-3 py-1.5 text-center text-xl font-bold outline-none"
              value={triggerName}
              onChange={(e) => setTriggerName(e.target.value)}
              placeholder="Untitled Group"
            />
            <div>
              <button
                onClick={closeModal}
                className="bg-1 rounded-lg p-1.5 transition-all duration-200"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
          <div className="flex flex-grow flex-col justify-between gap-8 p-6">
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 rounded-lg bg-zinc-950 px-3 py-2">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="rounded-lg border border-zinc-200 px-2 py-1 text-sm transition-all duration-200"
                >
                  ADD
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>
            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Save
              </Button>
            </div>
            {botCreationId && (
              <DataFunction
                title="Add integration"
                desc=" Select the app you’d like to add as integration."
                isOpen={isIntegrationModalOpen}
                onClose={() => {
                  setIsIntegrationModalOpen(false);
                  setEditOption(null);
                }}
                appsData={integrationData}
                selectedOptions={selectIntegrationOptions}
                setSelectedOptions={setSelectIntegrationOptions}
                editOption={editOption}
                botCreationId={botCreationId}
                setSelectedValue={setSelectedValue}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DataApps;
